// Spec 45 component-behavior — cmp_ds_drawer.
//
// Side drawer (right or left rail). Behaviorally a modal with edge-
// anchored layout: blocks page interaction, focus-trapped, Escape-
// dismissible, scrim-click-closeable. The visual difference (slides
// in from edge vs centered) is CSS-side; the behavior contract is
// identical to Modal.
//
// We compose Modal under the hood + add a `side` data-attr so
// stylesheets can pick the slide direction. This keeps focus-trap
// and a11y plumbing in ONE place (Modal); future Modal upgrades
// (focus-trap library swap, etc.) propagate to Drawer for free.

import { forwardRef, type ReactNode } from "react";

import { cx } from "../lib/cx.ts";
import { Modal, type ModalProps } from "../Modal/Modal.tsx";

export type DrawerSide = "left" | "right";

export interface DrawerProps extends ModalProps {
  readonly side?: DrawerSide;
  readonly children?: ReactNode;
}

export const Drawer = forwardRef<HTMLDivElement, DrawerProps>(
  ({ side = "right", className, children, ...rest }, ref) => (
    <Modal
      ref={ref}
      data-component="drawer"
      data-side={side}
      className={cx("nai-drawer", className)}
      {...rest}
    >
      {children}
    </Modal>
  ),
);
Drawer.displayName = "Drawer";
